const directive = {
    update(el,binding) {
      let count = Number(el.innerText) //初始值
	  let rate = 30;
	  let num = 1;
	  if(count < binding.value){
		  if(binding.value - count > 50){
		  		  rate = 30;
		  		  num = 3;
		  }
		  if(binding.value - count > 100){
		  		  rate = 30;
		  		  num = 11;
		  }
		  if(binding.value - count > 500){
		  		  rate = 30;
		  		  num = 31;
		  }
		  if(binding.value - count > 1000){
		  		  rate = 30;
		  		  num = 101;
		  }
		  if(binding.value - count > 5000){
		  		  rate = 30;
		  		  num = 301;
		  }
		  if(binding.value - count > 10000){
		  		  rate = 30;
		  		  num = 5001;
		  }
		  if(binding.value - count > 100000){
		  		  rate = 30;
		  		  num = 50001;
		  }
		  const timer = setInterval(() => {
		        // 将我们得到的值设置给count
		        count = count + num;
		        if(count > binding.value){
		          //为了防止数字错误将初始的值给他
		  			  // count = binding.value
		          el.innerText = binding.value
		          //清除定时器
		          clearInterval(timer)
		        }else{
		  				 el.innerText = count.toFixed(0)
		  			}
		  }, rate);
	  }else if(count > binding.value){
	  		  if(count - binding.value > 50){
	  		  		  rate = 30;
	  		  		  num = 3;
	  		  }
	  		  if(count - binding.value > 100){
	  		  		  rate = 30;
	  		  		  num = 11;
	  		  }
	  		  if(count - binding.value > 500){
	  		  		  rate = 30;
	  		  		  num = 31;
	  		  }
	  		  if(count - binding.value > 1000){
	  		  		  rate = 30;
	  		  		  num = 101;
	  		  }
	  		  if(count - binding.value > 5000){
	  		  		  rate = 30;
	  		  		  num = 301;
	  		  }
			  if(count - binding.value > 10000){
					  rate = 30;
					  num = 5001;
			  }
			  if(count - binding.value > 100000){
					  rate = 30;
					  num = 50001;
			  }
	  		  const timer = setInterval(() => {
	  		        // 将我们得到的值设置给count
	  		        count = count - num;
	  		        if(count < binding.value){
	  		          //为了防止数字错误将初始的值给他
	  		  			  // count = binding.value
	  		          el.innerText = binding.value
	  		          //清除定时器
	  		          clearInterval(timer)
	  		        }else{
	  		  			el.innerText = count.toFixed(0)
	  		  		}
	  		  }, rate);
	  }
	  
 
    },
  };
  export default directive